export default "__VITE_ASSET__DyZ$zETX__"